module.exports = __webpack_public_path__ + "img/Gc.82a7ec2a.png";